import * as React from 'react';
import {Fragment, useCallback, useEffect, useMemo, useState} from 'react';
import {
    AutocompleteInput,
    AutocompleteArrayInput,
    NumberField,
    ReferenceField,
    ReferenceInput,
    //ReferenceManyField,
    TextField,
    useListContext,
    useLocale,
    useTranslate,
    //SimpleShowLayout,
    useRecordContext,
    useGetManyReference,
    FilterLiveSearch,
    EditButton,
    TextInput,
    SimpleShowLayout,
    ReferenceManyField, Datagrid, FunctionField, ReferenceArrayInput, SelectArrayInput,
} from 'react-admin';
import {Tooltip} from "@material-ui/core";
import {Box} from '@mui/material';
import {Button, Dialog, DialogTitle, DialogContent, DialogActions} from '@mui/material';
// import Button from "@material-ui/core/Button";

import {CustomerInfo, DateFieldComp, FilterDataAside, MyCount, TextFieldBold} from "../../_common/CompReact";
import TableActions from "../../_common/TableActions";
import ListComponentAdmin from "../../_common/ListComponentAdmin";
import DatagridComponentAdmin from "../../_common/DatagridComponentAdmin";
import useMyStyles from "../../utils/useMyStyles";
import {useSelectedColumns} from "@react-admin/ra-preferences";
import {FloatNumber, formatSpacerNumber} from "../../_common/CompFormat/utils";
//import PostBulkActionButtons from "../_common/PostBulkActionButtons";
import CroppedLongField from "../../_common/CroppedLongField";
import {CardContent, TableBody, TableCell, TableRow, useMediaQuery} from "@material-ui/core";
import MySimpleList from "../../_common/MySimpleList";
import {useTheme} from '@mui/material/styles';

import get from "lodash/get";
import CardComp from "../../_common/Asside/CardComp";
import TrueFalseFilters from "../../_common/TrueFalseFilters";
import {validateReq} from "../../_constants/validateTable";
import Chip from "@material-ui/core/Chip";
import {theme} from "@react-admin/ra-navigation";
import PostBulkActionButtons from "../../_common/PostBulkActionButtons";
import config from "../../utils/config";
import IconButton from "@material-ui/core/IconButton";

import {KeyboardArrowDown, KeyboardArrowRight} from '@material-ui/icons';
import Table from "@material-ui/core/Table";
import DownloadIcon from "@material-ui/icons/GetApp";
import {fetchBlob} from '../../utils/keycloak';
import {useNotify} from "ra-core";
// import PublishIcon from '@mui/icons-material/Publish';

const TopFilters = (resource, locale, classes) => {
    const translate = useTranslate();
    let dt = [];
    dt.push(
        <Box alwaysOn label={translate('Customers')} sx={{minWidth: 520}} mb={'-20px'}>
            <ReferenceInput
                source="customer" reference="zCustomers" fullWidth
                alwaysOn label={translate('Customers')}
            >
                <AutocompleteInput optionText="name" resettable/>
            </ReferenceInput>
        </Box>
    );
    dt.push(<TextInput label={`${translate("Search")} ID`} source="search_int" alwaysOn style={{width: 150}} multiline
                       resettable/>)
    dt.push(
        <ReferenceArrayInput source="status_id_list" filter={{show_on_frontend: 'true'}}
                             reference="orderStatus" alwaysOn label={translate('Status')}
        >
            <AutocompleteArrayInput optionText={`name[${locale}]`} resettable/>
        </ReferenceArrayInput>
    );

    /*dt.push(<TextInput label={translate("Search")} source="q" style={{width: 250}} multiline resettable/>)*/
    return dt;
}
const UniversalAside = (props) => {
    const {locale} = props;
    const translate = useTranslate();
    return (
        <CardComp id="aside_card">
            <CardContent>
                {/*<FilterLiveSearch source={'question_en___containsi'} label={'Question'}/>*/}
                <FilterLiveSearch/>
                <FilterDataAside fields={'updated_at'} name={'Updated'}/>
                {/*<TrueFalseFilters field={'is_paid'} label={'Is paid'}/>*/}
                {/*<TrueFalseFilters field={'is_load'} label={'Exported to Xero'}/>*/}
                {/*<TrueFalseFilters field={'miles_only'} label={'miles only'}/>*/}
            </CardContent>
        </CardComp>
    )
};

/*const GetAddress = (props) => {
    const {source} = props
    const record = useRecordContext();

    return (
        <Box display={'grid'}>
            <span title={'Zip'}>{get(record, `${source}.zip`, null)}{', '}</span>
            <span title={'Province, City'}>
                {get(record, `${source}.province`, null)}{', '}
                {get(record, `${source}.city`, null)}{', '}
            </span>
            <span title={'Street, apartment'}>
                {get(record, `${source}.street`, null)}{', '}
                {get(record, `${source}.apartment`, null)}
            </span>
        </Box>
    )
}*/
export const TotalItems = (props) => {
    const record = useRecordContext();
    let product_prices = get(record, `pricing_data.product_prices`, [])
    const currency = 'UAH'
    return (
        <Box display={'grid'}>
            {product_prices.map((x, index) => {
                return (
                    <span>{index + 1}:
                        {get(x, `product.name`, '')}{' '}
                        (<b>{formatSpacerNumber(get(x, `result_price_all_currencies.${currency}.total_sum`, 0), '\u00a0')}</b>)
                    </span>
                )
            })
            }
        </Box>
    )
}
export const TotalSum = (props) => {
    const record = useRecordContext();
    let product_prices = get(record, `pricing_data.product_prices`, [])
    let currency = 'UAH'
    let sum = 0;
    product_prices.forEach((x) => {
        currency = get(x, `currency.iso3`, 'UAH')
        sum += get(x, `result_price_all_currencies.${currency}.total_sum`, 0)
    })
    return (<span><b>{formatSpacerNumber(sum, '\u00a0')}</b> {currency}</span>)
    // return null
}
const TextFieldStatus = (props) => {
    const {source, sourceTitle = null} = props
    const theme = useTheme();
    const record = useRecordContext();
    const status = get(record, source, null)
    let rgb_code = get(record, 'rgb_code', '')
    let title = ''
    if (sourceTitle) title = get(record, sourceTitle, '')

    rgb_code = rgb_code === '' ? '#fefefe' : rgb_code
    const textColor = theme.palette.getContrastText(rgb_code);
    return (
        <Box
            title={title}
            style={{
                color: textColor,
                backgroundColor: rgb_code,
                maxWidth: 120,
                borderRadius: 8,
                padding: 8
            }}
            label={status}
        >
            {status}
        </Box>

        /*return (
            <Chip
                title={title}
                style={{color: textColor, backgroundColor: rgb_code}}
                label={status}
            />*/
    )
    // return null
}
const TextFieldRoute = (props) => {
    const {source} = props
    const record = useRecordContext();
    let other_order_options = get(record, source, {})
    other_order_options = JSON.parse(other_order_options)
    const phone = get(other_order_options, 'phone', '')
    let delivery_address = get(other_order_options, 'delivery_address', '')
    // const date = delivery_address.match(/\b\d{2}\.\d{2}\.\d{2} \d{2}:\d{2}\b/);
    // console.log('other_order_options=====>', route)
    const result = delivery_address.match(/^(.*?\d{2}\.\d{2}\.\d{2} \d{2}:\d{2})/);
    const delivery_address_short = result ? result[1] : delivery_address;
    return (
        <Box display={'grid'}>
            {/*<em style={{color: 'brown'}}>{date}</em>*/}
            <span>{delivery_address_short}</span>
            <em style={{color: 'brown'}}>{phone}</em>
        </Box>
    )
    // return null
}
export const PublishFile = (props) => {
    const record = useRecordContext();
    const notify = useNotify();
    const translate = useTranslate();

    const [open, setOpen] = useState(false);

    const handleDownload = async () => {
        if (record.status === 20) {
            try {
                const response = await fetchBlob(`${config.apiUrl}api/get-order-file?order_id=${record.id}`);

                if (response.status >= 200 && response.status <= 300) {
                    const blob = await response.blob();

                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    const contentDisposition = response.headers.get('Content-Disposition');
                    let nameFile = `order_${record.id}.zip`; // имя по умолчанию

                    // console.log('contentDisposition=====>', response)
                    if (contentDisposition && contentDisposition.includes('filename=')) {
                        const match = contentDisposition.match(/filename="?([^"]+)"?/);
                        if (match && match[1]) {
                            nameFile = match[1];
                        }
                    }
                    a.download = nameFile;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    notify(`Create file ${nameFile}`, {type: 'success', autoHideDuration: 5000,});
                } else {
                    notify(`ERROR ${nameFile}`, {type: 'error', autoHideDuration: 8000,});
                }
            } catch (err) {
                console.log('err=======>', err.message);
                notify(err.message, {type: 'error', autoHideDuration: 8000});
            } finally {
                //console.log('finally=======>', 'finally');
            }
        } else {
            setOpen(true)
        }
    }

    const alarmText = translate('To download the order file, you must first stop the order unloading to the accounting system.')
    return (
        <>
            <Tooltip
                title={translate('To download the order file, you must first stop the order unloading to the accounting system.')}>
                <IconButton
                    style={{opacity: record.status === 20 ? 1 : 0.3}}
                    onClick={handleDownload}
                >
                    <DownloadIcon style={{color: 'cornflowerblue'}}/>
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={() => setOpen(false)}>
                {/*<DialogTitle>Подтверждение действия</DialogTitle>*/}
                <DialogContent>
                        <span style={{fontSize: 20}}>
                            {alarmText}
                        </span>
                </DialogContent>
            </Dialog>
        </>
    )
    // return null
}
export const OrderManagement = (props) => {
    const record = useRecordContext();
    const [open, setOpen] = useState(false);
    const notify = useNotify();

    const translate = useTranslate();

    let type = '';
    let bg = ''
    let alarmText = ''
    let typeText = ''
    if (record.status === 2) {
        type = 'Stop unloading';
        typeText = translate('Stop unloading')
        alarmText = translate('Are you sure you want to stop unloading to the accounting system?')
        bg = '#ffd7dd'
    } else if (record.status === 20) {
        type = 'Resume unloading';
        typeText = translate('Resume unloading')
        bg = '#c2feb4'
        alarmText = translate('Are you sure you want to resume unloadingto the accounting system?')
    }

    const handleDownload = async () => {
        try {
            const response = await fetchBlob(`${config.apiUrl}api/get-order-file?order_id=${record.id}`);

            if (response.status >= 200 && response.status <= 300) {
                const blob = await response.blob();

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                const nameFile = `order_${record.id}.xlsx`;
                a.download = nameFile;
                a.click();
                window.URL.revokeObjectURL(url);
                notify(`Create file ${nameFile}`, {type: 'success', autoHideDuration: 5000,});
            } else {
                notify(`ERROR ${nameFile}`, {type: 'error', autoHideDuration: 8000,});
            }
        } catch (err) {
            console.log('err=======>', err.message);
            notify(err.message, {type: 'error', autoHideDuration: 8000});
        } finally {
            //console.log('finally=======>', 'finally');
        }
    }

    const handleConfirm = () => {
        setOpen(false);
        // Выполнение действия
        notify('Изменен статус', {type: 'success'});
    };

    if (type)
        return (
            <>
                <Button
                    onClick={() => setOpen(true)}
                    style={{
                        // color: 'black',
                        backgroundColor: bg,
                        maxWidth: 120,
                        // borderRadius: 8,
                        // padding: 8,
                        fontSize: 12
                        // textAlighn: 'center'
                    }}
                    // label={translate(type)}
                >
                    {translate(typeText)}
                </Button>
                <Dialog open={open} onClose={() => setOpen(false)}>
                    {/*<DialogTitle>Подтверждение действия</DialogTitle>*/}
                    <DialogContent>
                        <span style={{fontSize: 20}}>
                            {alarmText}
                        </span>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => setOpen(false)}
                        >
                            {translate('Cancel')}
                        </Button>
                        <Button
                            onClick={handleConfirm}
                            color="primary" autoFocus
                        >
                            {translate('Confirmed')}
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        )
    else return null
    // return null
}

const ColumnsForList = (resource, locale, classes, isSmall) => {
    const translate = useTranslate();
    let columns = {
        id: <NumberField source="id" headerClassName={classes.headerShortWidth}/>,
        status:
            <ReferenceField
                source="status" reference="orderStatus"
                label={translate('Status')}
                link={false}
                sortable={false}
                textAlign={"center"}
            >
                <TextFieldStatus source={`name_${locale}`} textAlign={"center"} sourceTitle={'internal_name'}/>
            </ReferenceField>,

        updated: <DateFieldComp source="updated" label={translate('Updated')}
                                textAlign={'center'} locale={'ru'}
                                cellClassName={classes.date_st} showTime={true}/>,
        total: /*<TotalSum label={'Initial amount'} textAlign={"right"}/>,*/
            <FunctionField
                label={translate('Initial amount')}
                cellClassName={classes.rowCellRight}
                // sortBy={'additional.sum_sell'}
                sortable={false}
                render={record => {
                    if (!record) return null;
                    return (
                        <Box display={'grid'}
                             style={{
                                 opacity: 0.7,
                                 color: record.additional.sum_sell !== record.additional.sum_sell_current && 'red'
                             }}
                             cellClassName={classes.rowCellRight}
                             label={'Initial amount'}
                        >
                            <FloatNumber delim={'\u00a0'} show_0={true}
                                         source={`additional.sum_sell`}/>
                            <Box style={{marginLeft: 4}}>
                                <TextField source={`additional.sum_sell_currency`}/>
                            </Box>
                        </Box>
                    )
                }}
            />,
        total_current: /*<TotalSum label={'Current amount'} textAlign={"right"}/>,*/
            <Box display={'grid'} sortable={false} cellClassName={classes.rowCellRight}
                 label={translate('Current amount')}>
                <b><FloatNumber bold={true} delim={'\u00a0'} show_0={true}
                                source={`additional.sum_sell_current`}/></b>
                <Box style={{marginLeft: 4}}>
                    <TextField source={`additional.sum_sell_currency`}/>
                </Box>
            </Box>,
        /*items: <TotalItems label={'Products'} textAlign={"left"}/>,*/
        delivery_type:
            <ReferenceField
                label={translate('Delivery')}
                source="delivery_type"
                reference="deliveryType"
                link={false}
                sortable={false}
                textAlign={"center"}
                // cellClassName={classes.rowCellCenter}
            >
                {/*<Box>
                    <TextField source={`name_${locale}`}/>
                </Box>*/}
                <FunctionField
                    render={record => {
                        if (!record) return null;
                        if (record.id === 7) {
                            // return <Chip label={`⚡ ${record[`name_${locale}`]}`} style={{backgroundColor:"#ffe000"}}/>;
                            return <Chip label={`${record[`name_${locale}`]}`} style={{backgroundColor: "#ffe000"}}/>;
                        }
                        return <span>{record[`name_${locale}`]}</span>;
                    }}
                />
            </ReferenceField>,

        other_order_options:
            <TextFieldRoute source={`other_order_options`} textAlign={"left"} label={translate('Route')}
                            cellClassName={classes.other_order_options_short}/>,
        remark:
            <CroppedLongField long={80} source={'remark'} label={translate('Comment')}
                              cellClassName={classes.remark_st}/>,
        customer:
            <ReferenceField
                source="customer"
                reference="zCustomers"
                label={translate('Customer')}
                link={true}
                // sortBy={'zCustomers:name'}
                sortable={false}
                cellClassName={classes.customer_st_long}
            >
                {/*<CustomerInfo name={'name'} src={'avatar'}/>*/}
                <TextField source={'name'}/>
            </ReferenceField>,

        source: <CroppedLongField source="source" long={10} label={translate('Source')}/>,
        created: <DateFieldComp source="created" label={translate('Created')} textAlign={'center'}
                                locale={'us'} cellClassName={classes.date_st} showTime={true}/>,

        publish: <PublishFile/>,

        order_management: <OrderManagement textAlign={"center"}/>,
    }

    return columns;
};

const ColumnsForItems = (resource, locale, classes, isSmall) => {
    const translate = useTranslate();
    let columns = {
        id: <NumberField source="id" headerClassName={classes.headerShortWidth}/>,
        // article: <TextField source={`article`} label={translate('Article')}/>,
        // brand: <TextField source={`brand`} label={translate('Brand')}/>,
        article_brand:
            <Box display={'grid'} sortBy={'article'}
                 label={`${translate('Brand')} / ${translate('Article')} / ${translate('SKU')}`}
            >
                <TextFieldBold source={`brand`} label={translate('Brand')}/>
                <TextFieldBold source={`article`} label={translate('Article')}/>
                <TextField source={`sku_product`} label={translate('SKU')}/>
            </Box>,
        name: <TextField source={`name`} label={translate('Name')}/>,
        quantity:
            <FunctionField
                sortBy={'quantity'}
                label={translate('Quantity: current (initial)')}
                cellClassName={classes.rowCellRight}
                render={record => {
                    if (!record) return null;
                    return (
                        <Box display={'flex'} sortBy={'quantity'}
                             label={translate('Quantity: current (initial)')}
                        >
                            <FloatNumber bold={true} fix={0} delim={'\u00a0'} show_0={true}
                                         source={`current_quantity`}/>
                            <Box style={{
                                marginLeft: 4,
                                opacity: 0.7,
                                color: record.quantity !== record.current_quantity && 'red'
                            }}
                            >
                                (<FloatNumber fix={0} delim={'\u00a0'} show_0={true}
                                              source={`quantity`}/>)
                            </Box>
                        </Box>
                    )
                }}
            />,
        price_sell: <FloatNumber delim={'\u00a0'} source={`price_sell`} show_0={true}
                                 label={translate('Price')} textAlign={"right"}/>,
        sum_with_discount: <FloatNumber bold={true} delim={'\u00a0'} show_0={true}
                                        source={`sum_with_discount`}
                                        label={translate('Amount')} textAlign={"right"}/>,
        /*currency_sell:
            <ReferenceField
                source="currency_sell"
                reference="dCurrencies"
                // label={translate('Currency')}
                label={' '}
                link={false}
                sortBy={false}
                textAlign={"left"}
                cellClassName={classes.currency_min}
            >
                <TextField source={`simbol_${locale}`}/>
            </ReferenceField>,*/
        storage:
            <ReferenceField
                source="storage"
                reference="dSuppliersWarehouses"
                label={translate('Warehouse')}
                link={false}
                sortable={false}
                // cellClassName={classes.customer_st}
            >
                <TextField source={`name_${locale}`}/>
            </ReferenceField>,
        /*status:
        <Box label={`${translate('Status')} / ${translate('Invoice')}`} display={'grid'} sortBy={'invoice'}>
            <ReferenceField
                source="current_status"
                reference="orderStatus"
                label={translate('Status')}
                link={false}
                // sortBy={'invoice'}
                // cellClassName={classes.customer_st}
            >
                {/!*<TextField source={`name_${locale}`} textAlign={"center"}/>*!/}
                <TextFieldStatus source={`name_${locale}`} textAlign={"center"}/>
            </ReferenceField>
            <Box display={'grid'}
                 sortBy={'invoice_number'} label={translate('Invoice')}>
                <TextField source={`invoice_number`}/>
                <DateFieldComp source="invoice_date"
                                textAlign={'center'} locale={'ru'}
                               showTime={true}
                />
            </Box>
        </Box>,*/
        invoice_number:
            <Box display={'grid'} cellClassName={classes.rowCellleft}
                 sortBy={'invoice_number'} label={translate('Invoice')}>
                <TextField source={`invoice_number`}/>
                <DateFieldComp source="invoice_date"
                               textAlign={'center'} locale={'ru'}
                               showTime={true}
                />
            </Box>,
        status:
            <ReferenceField
                source="current_status"
                reference="orderStatus"
                label={translate('Status')}
                link={false}
                sortable={false}
                // cellClassName={classes.customer_st}
                textAlign={"center"}
            >
                <TextFieldStatus source={`name_${locale}`} textAlign={"center"}/>
            </ReferenceField>,

        updated: <DateFieldComp source="updated" label={translate('Updated')}
                                textAlign={'center'} locale={'ru'}
                                cellClassName={classes.date_st} showTime={true}/>,
    }
    return columns;
};
const PostShow = (props) => {
    const translate = useTranslate()
    const classes = useMyStyles();
    const {record, columns} = props;
    return (
        /*<SimpleShowLayout>*/
        <Box sx={{border: '1px solid #ddd'}}>
            <ReferenceManyField
                perPage={100}
                label={' '}
                // label={translate("Products")}
                reference="orderItems"
                target="order"
                bulkActionButtons={<PostBulkActionButtons/>}
                sort={{field: 'id', order: 'ASC'}}
            >
                {/*<Datagrid rowClick={(id) => `/booking/${id}/`} hasBulkActions>*/}
                <Datagrid>
                    {columns}
                </Datagrid>
            </ReferenceManyField>
        </Box>
        /*</SimpleShowLayout>*/
    );
}

const CustomDatagridWithExpand = ({columns, columnsForItems}) => {
    const {data, ids} = useListContext();
    const [expandedId, setExpandedId] = useState(null);

    const toggleExpand = (id) => {
        setExpandedId(prev => (prev === id ? null : id));
    };

    return (
        <Table>
            <TableBody>
                {ids.map(id => {
                    const record = data[id];
                    const isExpanded = expandedId === id;

                    return (
                        <React.Fragment key={id}>
                            <TableRow hover>
                                <TableCell>
                                    <IconButton onClick={() => toggleExpand(id)}>
                                        {isExpanded ? <KeyboardArrowDown/> : <KeyboardArrowRight/>}
                                    </IconButton>
                                </TableCell>

                                {/* Отображаем остальные поля */}
                                {columns.map((column, index) => (
                                    <TableCell key={index}>
                                        {/* предполагается, что column — это функция или React-элемент */}
                                        {React.cloneElement(column, {record})}
                                    </TableCell>
                                ))}
                            </TableRow>

                            {/* Вставляем expandable строку */}
                            {isExpanded && (
                                <TableRow>
                                    <TableCell colSpan={columns.length + 1}>
                                        <PostShow record={record} columns={columnsForItems}/>
                                    </TableCell>
                                </TableRow>
                            )}
                        </React.Fragment>
                    );
                })}
            </TableBody>
        </Table>
    );
};

const OrderList = ({permissions, ...props}) => {
    const classes = useMyStyles();
    const {resource} = props;

    //console.log(resource, 'MyCount====>')
    const locale = useLocale();
    const isSmall = useMediaQuery(function (theme) {
        return theme.breakpoints.down('xs');
    });

    /*const postRowStyle = (record, index) => ({
        backgroundColor: record.nb_views >= 500 ? '#efe' : 'white',
    });*/

    const postRowStyle = (record, index) => ({
        backgroundColor: record?.is_paid && '#efe',
        // display: "table-cell",
    });

    const columns = useSelectedColumns({
        preferences: `${resource}list.columns`,
        columns: ColumnsForList(resource, locale, classes, isSmall),
        omit: ["source", "items", "created"],
    });
    const columnsForItems = useSelectedColumns({
        preferences: `${resource}_orderItemslist.columns`,
        columns: ColumnsForItems('orderItems', locale, classes, isSmall),
        omit: [""],
    });
    return (
        <ListComponentAdmin
            {...props}
            //component={'div'}
            title={''}
            actions={<TableActions
                create={false}
                preference={`${resource}list.columns`}
                columns={ColumnsForList(resource, locale, classes, isSmall)}
                permissions={permissions}
                //asideFilter={true}
                // filter={false}
            />}
            //filterDefaultValues={{status_id_list: []}}
            filters={TopFilters(resource, locale, classes)}
            is_bulkActionButtons={false}
            //filterDefaultValues={{viewed: true}}
            // filter={{status: 2}}
            sort={{field: 'id', order: 'DESC'}}
            // aside={<UniversalAside locale={locale}/>}
        >
            {isSmall
                ?
                <MySimpleList
                    columns={columns}
                    postRowStyle={postRowStyle}
                />
                :
                <DatagridComponentAdmin
                    {...props}
                    // rowClick="edit"
                    rowStyle={postRowStyle}
                    expand={<PostShow columns={columnsForItems}/>}
                    // expandSingle={true}
                    /*isRowExpandable={row => (
                        //|| (row.travel_credits && row.travel_credits.length > 0)
                        (row && row.transactions && row.transactions.length > 0)
                    )}*/
                >
                    {/*<EditButton label={''} cellClassName={classes.headerButtonEdiWidth}/>*/}
                    {columns}
                    {/*<CustomDatagridWithExpand columns={columns} columnsForItems={columnsForItems} />*/}
                </DatagridComponentAdmin>
            }

        </ListComponentAdmin>
    )
};

export default OrderList;
